export function selectRow(event: MouseEvent): void {
  document.querySelector('tr.active')?.classList.remove('active');
  (event.currentTarget as HTMLElement).classList.add('active');
}
